import { createRouter } from '@tanstack/react-router';
import { routeTree } from '@src/routeTree.gen';

const rawBasePath = import.meta.env.VITE_URL_BASE_PATH ?? '';
export const basepath = rawBasePath ? `/${rawBasePath.replace(/^\/+|\/+$/g, '')}` : '/';

let lastRestoredLocation;

export const router = createRouter({
  routeTree,
  basepath,

  // Fix issues with unexpected scrolling
  scrollRestoration: ({ location }) => {
    const locationKey = `${location.state.__TSR_key ?? ''}:${location.href}`;
    if (locationKey === lastRestoredLocation) return false;
    lastRestoredLocation = locationKey;
    return true;
  },
  getScrollRestorationKey: (location) => location.pathname,
});
